export interface WebMCPTextContent {
  type: "text";
  text: string;
}

export interface WebMCPToolResult {
  content: WebMCPTextContent[];
}

export function jsonToolResult(value: unknown): WebMCPToolResult {
  return {
    content: [{ type: "text", text: JSON.stringify(value) }],
  };
}
